<template>
    <svg class="w-23 lg:w-25 h-px bg-linear-to-r from-primary-600 to-primary-200"></svg>
</template>